module.exports = __webpack_public_path__ + "static/penthouse-02d18596cabcf3c1fdfe83959d0936d0.jpg";